<template>
  <div>
    <div class="el-card__header card-header__wrap">
      <span class="card-header--title">
        <create-certificate-btn :fetch="fetchList" />
      </span>
      <div class="card-header--form">
        <el-input
          v-model="config.certName"
          placeholder="请输入证书名称"
          style="width: 200px">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"></el-button>
        </el-input>
      </div>
    </div>
    <el-table
      border
      :data="list">
      <el-table-column
        label="证书名称"
        :resizable="false"
        width="240">
        <template slot-scope="{row}">
          <link-route :link-to="`/certificate-detail?vendorId=${row.vendorId}&certId=${row.certId}`">
            {{ row.certName }}
          </link-route>
        </template>
      </el-table-column>
      <el-table-column
        label="有效期"
        :resizable="false"
        width="160">
        <template slot-scope="{row}">
          {{ row.certBeginTime | dateformat('YYYY-MM-DD') }} ~ {{ row.certEndTime | dateformat('YYYY-MM-DD') }}
        </template>
      </el-table-column>
      <el-table-column
        label="证书图片"
        :resizable="false">
        <template slot-scope="{row}">
          <image-list :list="row.certFileList" />
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        :resizable="false"
        width="80">
        <template slot-scope="{row}">
          <el-button
            type="danger"
            @click="deleteCert(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination-new
      v-model="config"
      :total="total"
      :fetch="fetchList" />
  </div>
</template>

<script>
import ImageList from '@/components/image-list.vue'
import CreateCertificateBtn from './busi/create-certificate-btn.vue'
import { mapState } from 'vuex'
export default {
  name: 'CertificateList',
  components: { ImageList, CreateCertificateBtn },
  props: {},
  data() {
    return {
      loading: false,
      config: {
        pageNum: 1,
        pageSize: 10,
        certName: '',
        vendorId: null
      },
      list: [],
      total: 0
    }
  },
  computed: {
    ...mapState({
      userPermission: state => state.account.permission,
      query: state => state.common.query
    })
  },
  created() {
    if (this.query) {
      this.config = {
        ...this.config,
        ...this.query
      }
    }
  },
  activated() {
    this.fetchList()
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    handleCurrentChange(current) {
      this.config.pageNum = current
      this.fetchList()
    },
    fetchList() {
      this.loading = true
      this.$store.commit('common/setQuery', this.config)
      this.$store.dispatch('certificate/getcertificates', {
        payload: this.config,
        success: (res) => {
          this.loading = false
          this.total = res.data.total
          this.list = res.data.records.map(item => {
            item.certFileList = item.certFile.split(',')
            item.certFile = item.certFile.split(',').map(o => ({ url: o }))
            return item
          })
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    deleteCert(row) {
      this.$confirm('此操作将永久删除该证书, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.loading = true
          this.$store.dispatch('certificate/deletecertificate', {
            payload: {
              certId: row.certId,
              vendorId: row.vendorId
            },
            success: () => {
              this.loading = false
              this.fetchList()
            },
            fail: () => {
              this.loading = false
            }
          })
        })
    }
  }
}
</script>
